import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    reason: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD",
    ),
    dateRange: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALUE_INTO_THE_FIELD",
    ),
    isRecurring: Yup.boolean().notRequired(),
    allSwitch: Yup.boolean().notRequired(),
    criteria: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.boolean(),
          type: Yup.string(),
        }),
      )
      .required()
      .min(
        1,
        "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_SELECT_ATLEAST_ONE_CRITERIA",
      ),
  });
};
